import { NAMESPACE as GLOBAL_NAMESPACE } from '../../constants';
import constants from './constants';

const PREFIX = `${GLOBAL_NAMESPACE}/${constants.NAMESPACE}` as const;

const FETCH_APP_STORAGE_FILES = `${PREFIX}/FETCH_APP_STORAGE_FILES` as const;
const INSTALL_APP = `${PREFIX}/INSTALL_APP` as const;
const RESET = `${PREFIX}/RESET` as const;

export default {
  FETCH_APP_STORAGE_FILES,
  INSTALL_APP,
  RESET,
};
